
<div mdiNoRightClick style="min-height: 100%!important; overflow: hidden!important">
    <mdi-menu></mdi-menu> 
    <router-outlet></router-outlet>
</div>
<!--
<div class="my-overlay" *ngIf="showOverlay">
    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
</div>
-->